const header = document.querySelector('.header');
const navMenu = $('.nav');
const hamburger = $('.hamburger');

hamburger.on('click', function() {
    navMenu.slideToggle();
    hamburger.toggleClass('is-active');
});


// Change header class on scroll
let initScrollPos = document.documentElement.scrollTop;
if (initScrollPos > 100) {
    header.classList.add('is-scrolled');
}

window.addEventListener('scroll', () => {
    let scrollPos = window.scrollY;
    if (scrollPos > 100) {
        header.classList.add('is-scrolled');
    } else {
        header.classList.remove('is-scrolled');
    }
});
